# A STUDENT-SCOPED SCREEN WITH NO STUDENT GOES HOME, NOT TO THE ERROR SCREEN.
# Card 6aaedd51a822f303b055f830 (group:portal-crashes), found by the
# group:robustness route crawl on 2026-09-19.
#
# THE DEFECT. Four screens — games, subjects, student_report and
# long_milestone_report — are written for a student that is already resolved,
# and each reads it straight out of `window.app` on the way up:
#
#   games                 getActiveStudent().birth_date        (games.coffee constructor)
#   subjects              getActiveStudent().posetProfiles      (subjects.coffee)
#   student_report        getActiveStudent().id                 (student_report.coffee)
#   long_milestone_report getActiveStudent().id                 (componentDidMount)
#
# All four are declared by the TEACHER and ORG routers as well as the parent's,
# and in those two shells nothing guarantees a student. `window.app.students`
# is built from the login's OWN account and `sharedStudents` only survives for
# a teacher (loopback_api.coffee:401), so an organization, school or district
# admin has an empty list and `getActiveStudent()` is undefined for every one
# of these URLs. The org portal has no links to them at all — every way in is a
# bookmark, a stale link, a student archived since, or the back button after a
# drill-down — and each one of those ends on "We have encountered an error".
#
# WHY A ROUTE GUARD AND NOT FOUR COMPONENT GUARDS. The components are SHARED
# with the parent shell, where the boot chain already routes a studentless
# session away before they mount; four defensive empty-states would be four
# new screens nobody designed, in three shells, to express one routing rule
# the app already has. The rule belongs where the app decides where you are.
#
# WHY IT LIVES IN ITS OWN FILE. Both staff routers need the identical rule and
# `requireLogin` is already copied into each of them; a third copy of a rule
# about WHICH CHILD a screen is showing is a copy that drifts. The shell-shaped
# part — its sign-in path and the name of its home state — stays in the shell.

# Is there a student for the screen this transition is entering?
#
# THE THREE ANSWERS, in the order a URL decides them:
#
#   1. `studentIds` — student_report's multi-student mode. A teacher opens a
#      whole folder from teacher.coffee:662, which passes studentIds and no
#      studentId; that path resolves every id itself and never reads the
#      active student. It must not be redirected.
#   2. `studentId` names a child. It has to RESOLVE, against the same list the
#      screen's own `digestParams` will latch it from. A named id that does not
#      resolve is the archived-student and stale-bookmark case, and answering
#      it with the previously active child would quietly show a teacher the
#      wrong student's report under the right student's URL.
#   3. No student in the URL at all. Then the active student is the subject,
#      exactly as it is for the parent shell, and only its absence is a
#      redirect.
hasStudentForScreen = (trans) ->
  params = trans?.params?() ? {}
  return true if params.studentIds?.length
  if params.studentId?
    return window.app?.getStudentById?(params.studentId)?
  return window.app?.getActiveStudent?()?

# The `redirectTo` answer: a target state when this screen has no student to
# show, and nothing at all when it does. Returning undefined is what lets the
# transition proceed, so the guard is silent on every working drill-down.
export studentRedirect = (trans, homeState) ->
  return if hasStudentForScreen trans
  console.log "No student to show on #{trans?.targetState?()?.name?() ? 'this screen'} — routing back to #{homeState}"
  return {state: homeState}
